<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="组卷人">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" title="选择组卷人" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSeachUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="试卷名称">
                  <el-input style="width: 177px;" v-model="queryForm.paperName"></el-input>
              </el-form-item>
              <el-form-item label="试卷分类">
<!--                  <el-input style="width: 177px;" v-model="queryForm.categoryId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.categoryId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="eduExampaperCategoryList"
                          :props="treeProps"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item label="科目">
<!--                  <el-input style="width: 177px;" v-model="queryForm.subjectId"></el-input>-->
                  <el-select
                      clearable
                      style="width: 177px"
                      v-model="queryForm.subjectId"
                      placeholder="请选择"
                      size="small"
                  >
                      <el-tree
                          :data="eduSubjectList"
                          :props="treePropsSubject"
                          :render-after-expand="false"
                      >
                          <div
                              class="custom-tree-node flex items-center"
                              slot-scope="{ node, data }"
                          >
                              <el-option
                                  :label="node.label"
                                  :value="data.id"
                              > </el-option>
                          </div>
                      </el-tree>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduExampaperList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduExampaper"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduExampaper(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduExampaper(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduExampaperList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduExampaperList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduExampaperList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="组卷人"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="paperName"
        label="试卷名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="categoryId"
        label="试卷分类"
        width="180"
      >
          <template scope="scope">
              <span>{{ scope.row.category ? scope.row.category.categoryName : '' }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="subjectId"
        label="科目"
        width="180"
      >
          <template scope="scope">
              <span>{{ scope.row.subject ? scope.row.subject.subjectName : '' }}</span>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="500"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="createEduExampaper(scop.row.id,scop.row.paperName)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">组卷</span>
              </div>
              <div @click="addRecord(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">考试记录</span>
              </div>
              <div @click="addFx(scop.row.id)">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">试卷分析</span>
              </div>
            <div @click="checkEduExampaper(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduExampaper(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduExampaper(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduExampaperStates[eduExampaperState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduExampaper"
          ref="eduExampaperForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="组卷人"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduExampaper.userId"-->
<!--              :disabled="eduExampaperState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" title="选择组卷人" labelName="userName" :disabled="eduExampaperState == 'check'"
                           labelValue="id" :value="eduExampaper.userId" :limit='1' size='small' placeholder='请选择用户'
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="试卷名称"
            prop="paperName"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExampaper.paperName"
              :disabled="eduExampaperState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="试卷分类"
            prop="categoryId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduExampaper.categoryId"-->
<!--              :disabled="eduExampaperState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  :disabled="eduExampaperState == 'check'"
                  v-model="eduExampaper.categoryId"
                  placeholder="请选择"
                  size="small"
              >
                  <el-tree
                      :data="eduExampaperCategoryList"
                      :props="treeProps"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="科目"
            prop="subjectId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 177px;"-->
<!--              v-model="eduExampaper.subjectId"-->
<!--              :disabled="eduExampaperState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  clearable
                  style="width: 177px"
                  v-model="eduExampaper.subjectId"
                  placeholder="请选择"
                  :disabled="eduExampaperState == 'check'"
                  size="small"
              >
                  <el-tree
                      :data="eduSubjectList"
                      :props="treePropsSubject"
                      :render-after-expand="false"
                  >
                      <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                      >
                          <el-option
                              :label="node.label"
                              :value="data.id"
                          > </el-option>
                      </div>
                  </el-tree>
              </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduExampaper.sort"
              :disabled="eduExampaperState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduExampaperState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>

      <!-- 组卷 -->
      <el-dialog
          title="组卷管理"
          :visible.sync="eduDialog"
          width="70%"
          :top="'8vh'"
          @close="closeEduDialog"
          :close-on-click-modal="false"
      >
          <EduCreateExampaper style="height: 70vh" ref="eduCreateExampaper"></EduCreateExampaper>

<!--          <div-->
<!--              slot="footer"-->
<!--              class="flex justify-end"-->
<!--          >-->
<!--              <el-button @click="closeEduDialog">关闭</el-button>-->
<!--              <el-button-->
<!--                  type="primary"-->
<!--                  @click="submitForm"-->
<!--              >确定</el-button>-->
<!--          </div>-->
      </el-dialog>

      <!-- 考试记录 -->
      <el-dialog
          title="考试记录"
          :visible.sync="showRecordDialog"
          width="60%"
          @close="closeRecordDialog"
          :append-to-body="true"
      >
          <EduExerciseExam style="height: 500px" ref="record"></EduExerciseExam>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeRecordDialog">关闭</el-button>
          </div>
      </el-dialog>

      <!--      试卷分析-->
      <el-dialog
          title="试卷分析"
          :visible.sync="showAnalysisDialog"
          width="60%"
          @close="closeAnalysisDialog"
          :append-to-body="true"
      >
          <EduExerciseExamAnalysis style="height: 500px" ref="analysis"></EduExerciseExamAnalysis>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeAnalysisDialog">关闭</el-button>
          </div>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import EduCreateExampaper from '@/components/edu/EduCreateExampaper.vue'
import { f } from 'vue-print-nb/lib/print.common';
import EduExerciseExam from '@/components/edu/EduExerciseExam.vue';
import EduExerciseExamAnalysis from '@/components/edu/EduExerciseExamAnalysis.vue';

export default {
    components: {
        EduExerciseExamAnalysis,
        EduExerciseExam,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        EduCreateExampaper
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduExampaperList();
                    this.getEduExampaperList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduExampaperList();
                    this.getEduExampaperList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     userId: '', //组卷人
                     paperName: '', //试卷名称
                     categoryId: '', //试卷分类
                     subjectId: '', //科目
                     sort: '', //排序
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduExampaperState: 'add',
                eduExampaperStates: {
                    add: '新建试卷',
                    check: '查看试卷',
                    edit: '修改试卷'
                },
                eduExampaperCategoryList: [],
                treeProps: {
                    children: 'children',
                    label: 'categoryName'
                },
                multipleSelection: [],
                eduExampaperList: [],
                eduExampaper: {
                    id: '', //
                    userId: '', //组卷人
                    paperName: '', //试卷名称
                    categoryId: '', //试卷分类
                    subjectId: '', //科目
                    sort: '', //排序
                },
                btnLoading: false,
                eduSubjectList: [],
                treePropsSubject: {
                    children: 'children',
                    label: 'subjectName'
                },
                rules: {
                    userId: [{ required: true, message: '组卷人不能为空', trigger: 'blur' }],
                    paperName: [{ required: true, message: '试卷名称不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '试卷分类不能为空', trigger: 'blur' }],
                    subjectId: [{ required: true, message: '科目不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },
                eduDialog: false,
                showRecordDialog: false,
                showAnalysisDialog: false
            };
        },
        created() {
            this.getEduExampaperList();
            this.getEduExampaperCategoryList();
            this.getEduSubjectList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            addFx(id){
                this.showAnalysisDialog = true;
                this.$nextTick(()=>{
                    this.$refs.analysis.init(id, 1);
                })
            },
            closeAnalysisDialog(){
                this.showAnalysisDialog = false;
            },
            createEduExampaper(id,name){
                this.eduDialog = true;
                this.$nextTick(()=>{
                    this.$refs.eduCreateExampaper.paperName= name;
                    this.$refs.eduCreateExampaper.init(id)
                })
            },
            addRecord(id){
                this.showRecordDialog = true;
                this.$nextTick(()=>{
                    this.$refs.record.init(id, 2);
                })
            },
            closeRecordDialog(){
                this.showRecordDialog = false;
            },
            closeEduDialog(){
                this.eduDialog = false;
                this.$refs.eduCreateExampaper.reset();
            },
            getEduSubjectList() {
                get(`/edu/subject/findAllAsTree`).then((res) => {
                    if (res.success) {
                        this.eduSubjectList = res.treeData;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            resetEduExampaperList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduExampaperList = [];
            },
            resetDialog() {
                this.eduExampaperState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //组卷人
                      paperName: '', //试卷名称
                      categoryId: '', //试卷分类
                      subjectId: '', //科目
                      sort: '', //排序
                };
                this.getEduExampaperList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduExampaper = {
                      id: '', //
                      userId: '', //组卷人
                      paperName: '', //试卷名称
                      categoryId: '', //试卷分类
                      subjectId: '', //科目
                      sort: '', //排序
                };
            },
            getEduExampaperCategoryList() {
                get(`/edu/exampapercategory/findAllAsTree`).then((res) => {
                    if (res.success) {
                        this.eduExampaperCategoryList = res.treeData;
                    }
                });
            },
            submitForm() {
                if (this.eduExampaperState == 'add') {
                    this.$refs.eduExampaperForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/exampaper/add`,{ ...this.eduExampaper }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduExampaperList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduExampaperState == 'edit') {
                    this.$refs.eduExampaperForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduExampaper.user;
                            delete this.eduExampaper.category;
                            delete this.eduExampaper.subject;
                            post(`/edu/exampaper/edit`,{ ...this.eduExampaper }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduExampaperList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduExampaper() {
                this.showDialog = true;
                this.eduExampaperState = 'add';
            },
            getValueUser(value) {
                this.eduExampaper.userId = value
            },
            getSeachUser(value) {
                this.queryForm.userId = value
            },
            checkEduExampaper(eduExampaperId) {
                console.log(eduExampaperId);
                this.currentEduExampaperId = eduExampaperId;

                this.getEduExampaperById();
                this.showDialog = true;
                this.eduExampaperState = 'check';
            },
            editEduExampaper(eduExampaperId) {
                console.log('eduExampaper', eduExampaperId);
                if (eduExampaperId) {
                    this.currentEduExampaperId = eduExampaperId;
                    this.getEduExampaperById();
                } else {
                    this.eduExampaper = { ...this.eduExampaper, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduExampaperState = 'edit';
            },
            deleteEduExampaper(eduExampaperId) {
                let ids = '';
                if (eduExampaperId) {
                    ids = eduExampaperId;
                } else {
                    ids = this.multipleSelection.map((eduExampaper) => eduExampaper.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/exampaper/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduExampaperList();
                                this.getEduExampaperList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduExampaperList() {
                this.resetEduExampaperList();
                this.getEduExampaperList();
            },
            getEduExampaperList(query = {}) {
                this.loading = true;
                get(`/edu/exampaper/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduExampaperList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduExampaperById() {
                get(`/edu/exampaper/get`,{ id: this.currentEduExampaperId }).then((res) =>{
                    if(res.success){
                      this.eduExampaper = { ...this.eduExampaper, ...res.eduExampaper };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduExampaperList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/exampaper/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/exampaper/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/exampaper/importData`,formData);
              this.refreshEduExampaperList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduExampaperList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduExampaperList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>